var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './SonarText.scss';
import classNames from 'classnames';
import { isBoolean } from '@sonar-software/sonar-ts-lib';
import ResizeObserver from 'rc-resize-observer';
import React, { useCallback, useRef, useState } from 'react';
import { Tooltip, Typography } from 'antd';
import { useOnMount, useOnUnmount } from '@hooks';
const { Link, Text } = Typography;
export const SonarText = (_a) => {
    var _b, _c;
    var { children, ellipsis, link, size = 14, weight, className, type } = _a, props = __rest(_a, ["children", "ellipsis", "link", "size", "weight", "className", "type"]);
    const spanRef = useRef(null);
    const textWeight = weight ? `-${weight}` : '';
    const textClassNames = classNames(`sonar-text text-${size}${textWeight}`, { secondary: type === 'secondary' }, className);
    const [hasOverflow, setHasOverflow] = useState(false);
    const handleResize = useCallback(() => {
        const container = spanRef.current;
        if (!container) {
            return;
        }
        setHasOverflow(container.offsetWidth < container.scrollWidth);
    }, []);
    useOnMount(() => {
        window.addEventListener('resize', handleResize);
    });
    useOnUnmount(() => {
        window.removeEventListener('resize', handleResize);
    });
    if (link) {
        const { onClick } = props, linkProps = __rest(props, ["onClick"]);
        return (React.createElement(Link, Object.assign({ className: textClassNames, onClick: onClick }, linkProps), children));
    }
    const text = React.createElement(Text, Object.assign({ className: textClassNames, ellipsis: Boolean(ellipsis), ref: spanRef }, props), children);
    if (!ellipsis) {
        return text;
    }
    const ellipsisTooltip = (_c = (isBoolean(ellipsis) ? {} : (_b = ellipsis) !== null && _b !== void 0 ? _b : {}).tooltip) !== null && _c !== void 0 ? _c : {};
    const tooltipChildren = React.isValidElement(ellipsisTooltip) ?
        ellipsisTooltip :
        ellipsisTooltip.children || children;
    const tooltipProps = (React.isValidElement(ellipsisTooltip) ? {} : ellipsisTooltip);
    tooltipProps.children = undefined;
    return (React.createElement(ResizeObserver, { onResize: handleResize },
        React.createElement(Tooltip, Object.assign({}, tooltipProps, { overlay: tooltipChildren, placement: 'bottom', showArrow: true, trigger: hasOverflow ? ['hover'] : [] }), text)));
};
